import React, { Component } from 'react';
import { Field, FieldArray, reset } from 'redux-form'
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data, CheckboxEditor } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button} from 'react-bootstrap';
import { SkyLightStateless } from 'react-skylight';
import _ from 'lodash';
import { Translate, Localize } from 'react-redux-i18n';

import { Selection } from '../Common/selection';
import { InputField, DisabledInputField } from '../Common/inputField';
import SpinnerButton from '../Common/SpinnerButton';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import PackageTypes from '../../containers/Products/packageTypes';
import { isARC, isGFD, isOLG, isVAK } from '../../actions/root_url';

const createPackageTypesDialogStyle = {
  width: '650px',
  marginLeft: '-15%',
}

class RowRenderer extends Component {
  PropTypes: {
    onDoubleClick: React.PropTypes.func
  };
  render() {
    return (<div onDoubleClick={ ()=>{ this.props.onDoubleClick(this.props.row, this.props.field) } } ><ReactDataGrid.Row ref="row" {...this.props} /></div>)
  }
}

let sizeRadios = props => {
  return (
    <div className="form-group">
      <div className="col-xs-6 text-nowrap">
        <input {...props.input} type="radio" value="true"
          checked={props.input.value === true || props.input.value === "true"}/>
        <Translate value="msg_large_prod" />
      </div>
      <div className="col-xs-6 text-nowrap">
        <input {...props.input} type="radio" value="false"
          checked={props.input.value === false || props.input.value === "false"}/>
        <Translate value="msg_small_prod" />
      </div>
    </div>
  )
}

 export class EditGroupForm extends Component {
  constructor() {
    super();
    this.state = {
      gfdGroupOptions: [],
      group: null,
      category: null,
      suggestedProdNum: null,
      isLinked: false,
      linkProdOpen: false,
      products: {
        rows: [],
        filters: {},
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      initial: false
    }
    this.openLinkProd = this.openLinkProd.bind(this);
    this.closeLinkProd = this.closeLinkProd.bind(this);
    this.selectExistingProd = this.selectExistingProd.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }

  componentWillMount() {
    let test = null;
    if (isARC && !this.props.formContent) {
      test = this.getLastDigitOptions();
      this.props.setValue('editGroupForm', 'Category', this.props.groupArc.ProductCategory1_id);
      this.props.setValue('editGroupForm', 'Group', this.props.groupArc.ProductGroup_id);
      this.props.setValue('editGroupForm', 'IsLarge', (this.props.groupArc.IsLarge === "false")? false: this.props.groupArc.IsLarge);
      // this.props.setValue('editGroupForm', 'LastDigit', 1);
      if (test && test.length > 0) {
        setTimeout(() => {
          this.props.setValue('editGroupForm', 'LastDigit', test[0].value);
        }, 800);
      }
    }
    if(this.props.formContent) {
      this.props.setValue('editGroupForm', 'Department', this.props.formContent.ProductDepartment_id)
      this.props.setValue('editGroupForm', 'Category', this.props.formContent.ProductCategory1_id)
      this.props.setValue('editGroupForm', 'Group', this.props.formContent.ProductGroup_id)
      this.props.setValue('editGroupForm', 'Name', this.props.formContent.Name)
      this.props.setValue('editGroupForm', 'Description', this.props.formContent.Description)
      this.props.setValue('editGroupForm', 'IsLarge', (this.props.formContent.IsLarge === "false")? false: this.props.formContent.IsLarge)
      this.props.setValue('editGroupForm', 'LastDigit', parseInt(this.props.formContent.LastDigit))
      this.props.setValue('editGroupForm', 'isMadePrev', this.props.formContent.isMadePrev)
      this.props.fetchSuggestDigit(this.props.formContent.ProductNum);
      let suggestedProdNum = this.props.formContent.suggestedProdNum
      let isLinked = this.props.formContent.isLinked
      this.setState({suggestedProdNum, isLinked})
    }
    if(this.props.formContent && this.props.formContent.suggestedProdNum) {
      this.setState({initial: true})
    }
    if (isVAK) {
      this.props.setValue('editGroupForm', 'IsLarge', false);
      this.props.setValue('editGroupForm', 'LastDigit', 1);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(isGFD && nextProps.Department && nextProps.Department != this.props.Department) {
      this.props.fetchDepCategories(nextProps.Department.value || nextProps.Department, true);
      if (this.props.Department) {
        this.props.setValue('editGroupForm', 'Group', null);
        this.props.setValue('editGroupForm', 'Category', null);
        this.props.setValue('editGroupForm', 'IsLarge', null);
        this.props.setValue('editGroupForm', 'LastDigit', null);
        this.setState({category: null, suggestedProdNum: null, isLinked: false })
      }
    }
    let gfdTemp = [];
    if (nextProps.depCategoriesAlt && nextProps.depCategoriesAlt.length > 0) {
      nextProps.depCategoriesAlt.map((r,i) => {
        gfdTemp.push({label: r.Name, value: r.ProductGroup_id});
      });
      this.setState({gfdGroupOptions: gfdTemp});
    } else {
      this.setState({gfdGroupOptions: []});
    }

    if(nextProps.Group && nextProps.Group != this.props.Group) {
      this.props.fetchGroupCategories(nextProps.Group.value || nextProps.Group, true);
      let index = _.findIndex(this.props.groups, {ProductGroup_id: nextProps.Group.value || nextProps.Group})
      if(index > -1) {
        let group = { ...this.props.groups[index] };
        if(group.GroupNum.length < 2) {
          group.GroupNum = "0" + group.GroupNum;
        }
        this.setState({ group })
      }
      if(this.props.Group) {
        this.props.setValue('editGroupForm', 'Category', null);
        this.props.setValue('editGroupForm', 'IsLarge', null);
        this.props.setValue('editGroupForm', 'LastDigit', null);
        if (!isVAK) {
          this.props.setValue('editGroupForm', 'IsLarge', null);
          this.props.setValue('editGroupForm', 'LastDigit', null);
        }
        this.setState({category: null, suggestedProdNum: null, isLinked: false })
      }
    }
    if(nextProps.Category && nextProps.Category !== this.props.Category) {
      // here cause issue
      let index = _.findIndex(isGFD ? this.props.groupCategoriesAlt : this.props.groupCategories, {ProductCategory_id: nextProps.Category.value || nextProps.Category})
      
      if(index > -1) {
        this.setState({category: isGFD ? this.props.groupCategoriesAlt[index] : this.props.groupCategories[index]})
      }
      // this cause infinity loop, so I remove it for gfd, gfd change to pass category id only
      // this.props.fetchSuggestedProdNum(isGFD ? this.props.groupCategoriesAlt[index].ProductCategory_id : this.props.groupCategories[index].ProductCategory_id)
      if (!isGFD) {
        this.props.fetchSuggestedProdNum(this.props.groupCategories[index].ProductCategory_id)
      }
      
      if(this.props.Category) {
        if (!isVAK) {
          this.props.setValue('editGroupForm', 'IsLarge', null);
          this.props.setValue('editGroupForm', 'LastDigit', null);
        }
      }
    }
    if((nextProps.suggestedProdNumFetched !== null) && nextProps.suggestedProdNumFetched != this.props.suggestedProdNumFetched) {
      if(this.state.initial) {
        this.setState({initial: false});
      }
      else {
        this.setState({suggestedProdNum: nextProps.suggestedProdNumFetched, isLinked: false})
        if (!isVAK) {
          this.props.setValue('editGroupForm', 'IsLarge', null);
          this.props.setValue('editGroupForm', 'LastDigit', null);
        }
      }
    }
    if(nextProps.existingProd && nextProps.existingProd != this.props.existingProd) {
      let products = {...this.state.products, rows: nextProps.existingProd}
      this.setState({products})
    }
    if(nextProps.IsLarge && nextProps.IsLarge != this.props.IsLarge) {
      if(nextProps.IsLarge == "false" || nextProps.IsLarge == false) {
        this.props.setValue('editGroupForm', 'LastDigit', 1);
        this.props.clearSuggestDigit();
      }
      else {
        if(this.state.group && this.state.category && this.state.suggestedProdNum) {
          let prodNum = `${this.state.group.GroupNum}${this.state.category.CategoryNum}${this.state.suggestedProdNum}`
          this.props.fetchSuggestDigit(prodNum);
        }
        if(!isVAK && this.props.IsLarge !== undefined) {
          this.props.setValue('editGroupForm', 'LastDigit', null);
        }
      }
    }
  }

  clearFields() {
    this.props.setValue('editGroupForm', 'Category', null);
    this.props.setValue('editGroupForm', 'Group', null);
    this.props.setValue('editGroupForm', 'Name', null);
    this.props.setValue('editGroupForm', 'Description', null);
    this.props.setValue('editGroupForm', 'IsLarge', null);
    this.props.setValue('editGroupForm', 'LastDigit', null);
    this.setState({ group: null, category: null, suggestedProdNum: null, isLinked: false })
  }

  handleSaveOnClick = (event) => {
    
    let {Department, Group, Category} = this.props;
    const GroupNum = this.state.group.GroupNum;
    
    const suggestedProdNum = this.state.suggestedProdNum;
    const LastDigit = (typeof this.props.LastDigit === 'object')?
      this.props.LastDigit.value:
      this.props.LastDigit;
    const productId = this.props.productId;
  
    if (isGFD) {
      // Category
      let c = Category;
      if (Category.value) {
        c = Category.value
      }
      
      this.props.saveAction(productId, c, () => {
        Promise.resolve(this.props.saveCallback(productId)).then(() => {
          this.props.closeG();
        });
      })
      
    } else {
      const CategoryNum = this.state.category.CategoryNum;
      let productNum = `${GroupNum}${CategoryNum}${suggestedProdNum}${LastDigit}`;
      if (isVAK) {
        productNum = `${GroupNum}${CategoryNum}${suggestedProdNum}`;
      }
      this.props.saveAction(productId, productNum, () => {
        Promise.resolve(this.props.saveCallback(productId)).then(() => {
          this.props.closeG();
        });
      });
  }
  }

  selectExistingProd(prod) {
    let suggestedProdNum = prod.ProductNum.slice(4, 7);
    this.setState({suggestedProdNum, isLinked: true, linkProdOpen: false})
    this.props.setValue('editGroupForm', 'IsLarge', null);
    this.props.setValue('editGroupForm', 'LastDigit', null);
  }

  getDepOptions() {
    var productDepOptions = [];
    if(this.props.deps) {
      this.props.deps.map(dep => {
        if (localStorage.getItem('lang') === 'en') {
          productDepOptions.push({value: dep.ProductDepartment_id, label: dep.Name})
        } else {
          productDepOptions.push({value: dep.ProductDepartment_id, label: dep.Description})
        }
      });
    }
    return productDepOptions;
  }

  getGroupOptions() {
    var productGroupOptions = [];
    if(this.props.groups) {
      this.props.groups.map(group => {
          productGroupOptions.push({ value: group.ProductGroup_id, label: group.Name })
      });
    }
    return productGroupOptions;
  }

  getCategoryOptions() {
    let categoryOptions = [];
    if (isGFD) {
      this.props.groupCategoriesAlt.map(category => {
        categoryOptions.push({value: category.ProductCategory_id, label: category.Name})
      })
    } else {
      this.props.groupCategories.map(category => {
        categoryOptions.push({value: category.ProductCategory_id, label: category.Name})
      })
    }
    return categoryOptions;
  }

  getLastDigitOptions() {
    let lastDigitOptions = [{value: 1, label: 1}];
    if(this.props.IsLarge && this.props.suggestDigitFetched) {
      lastDigitOptions = [];
      this.props.suggestDigitFetched.map(digit => {
        lastDigitOptions.push({value: digit, label: digit})
      })
      if(this.props.isMadePrev && this.props.LastDigit) {
        lastDigitOptions.push({
          value: parseInt(this.props.LastDigit),
          label: parseInt(this.props.LastDigit),
        });
        lastDigitOptions.sort((a, b) => { return (a.label > b.label); });
      }
    }
    return lastDigitOptions;
  }

  openLinkProd() {
    this.state.products.filters = {};
    this.setState({linkProdOpen: true});
  }

  closeLinkProd() {
    this.setState({linkProdOpen: false});
  }

  renderExistingProd() {
    if (this.props.existingProdIsLoading && !this.props.existingProdError) return <Spinner/>
    else if (this.props.existingProdError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.existingProdError)}</div></ContentWrapper>
    else {
        // Parameters of the react-data-grid
      const getRows = () => {
        return Data.Selectors.getRows(this.state.products);
      }

      const getSize = () => {
        return getRows().length;
      }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var products = Object.assign({}, this.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState({products});
      }

      const handleFilterChange = (filter) => {
        let newFilters = Object.assign({}, this.state.products.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const products = { ...this.state.products, filters: newFilters };
        this.setState({ products });
      }

      const onClearFilters = () => {
        // all filters removed
        const products = { ...this.state.products, filters: {} };
        this.setState({ products });
      };

      // Column difinition
      const columns = [
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          filterable: true,
          resizable: true,
          sortable: true,
          width: 100,
          // filterRenderer: FilterByStart,
        },
        {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          filterable: true,
          resizable: true,
          sortable: true,
          width: 90,
          // filterRenderer: FilterByStart,
        },
        {
          key: 'Name',
          name: <Translate value="prod_name" />,
          filterable: true,
          resizable: true,
          sortable: true,
          width: 300,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          filterable: true,
          resizable: true,
          sortable: true,
        },
      ]

      return (
        <Row>
          <Col sm={ 12 }>
            <div style={{ maxWidth: '100%', marginTop: '10px' }}>
              <ReactDataGrid
                enableCellSelect={true}
                rowRenderer={<RowRenderer onDoubleClick={this.selectExistingProd} />}
                rowKey='Product_id'
                rowHeight={25}
                headerRowHeight={45}
                minHeight={350}
                toolbar={<Toolbar enableFilter={true} />}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                onGridSort={handleGridSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={getSize()}
              />
            </div>
          </Col>
        </Row>
      )
    }
  }

  render() {
    const groupOptions = this.getGroupOptions();
    const categoryOptions = this.getCategoryOptions();
    const lastDigitOptions = this.getLastDigitOptions();
    const depOptions = this.getDepOptions();

    let createDialogStyle = {
        width: '800px',
        height: '500px',
        marginLeft: '-15%',
    };
    const isLinkable = (this.state.category && this.state.category.ProductCategory_id) ? true: false;
    let LastDigit = this.props.LastDigit;
    if (typeof this.props.LastDigit === 'object' && this.props.LastDigit !== null) {
      LastDigit = this.props.LastDigit.value;
    }
    let ProductNum = `${this.state.group && this.state.group.GroupNum}${this.state.category && this.state.category.CategoryNum}${this.state.suggestedProdNum && this.state.suggestedProdNum}${LastDigit}`
    return (
      <ContentWrapper>
        <div className="create-a-new-product-form" id="manage-products">
          {
          !isGFD &&
          <Row className="product-num-header">
            <label className="mr-md"><Translate value="prod_num" /></label>
              {this.state.group && <label className="prod-num-border">{this.state.group.GroupNum}</label>}
              {this.state.category && <label className="prod-num-border">{this.state.category.CategoryNum}</label>}
              {this.state.suggestedProdNum && <label className="prod-num-border">{this.state.suggestedProdNum}</label>}
              {!isVAK && (LastDigit || LastDigit === 0) && <label className="prod-num-border">{LastDigit}</label>}
          </Row>
          }
        <Panel className="product-form-navigation-1">
          {isGFD &&
            <Row>
              <label className="col-xs-5"> <span className="primary">00</span> <Translate value="please_select_department" /><span className="asteriksReq">*</span></label>
              {/* <Col xs={1}>{ this.state.group && this.state.group.GroupNum }</Col> */}
              <Col xs={6}><Field name="Department" component={Selection} options={depOptions}/></Col>
            </Row>
          }
          <Row>
            <label className="col-xs-5"> <span className="primary">01</span> <Translate value="please_select_group" /><span className="asteriksReq">*</span></label>
            {!isGFD && <Col xs={1}>{ this.state.group && this.state.group.GroupNum }</Col>}
            <Col xs={6}><Field name="Group" component={Selection} options={isGFD ? this.state.gfdGroupOptions : groupOptions}/></Col>
          </Row>
          <Row>
            <label className="col-xs-5"> <span className="primary">02</span> <Translate value="please_select_category" /><span className="asteriksReq">*</span></label>
            {!isGFD && <Col xs={1}>{ this.state.category && this.state.category.CategoryNum }</Col>}
            <Col xs={6}><Field name="Category" component={Selection} options={categoryOptions}/></Col>
          </Row>
          {
            !isGFD &&
            <Row>
              <label className="col-xs-5"> <span className="primary">03</span> <Translate value="new_series_no" /><span className="asteriksReq">*</span></label>
              <Col xs={3}><Field name="SeriesNum" component={DisabledInputField} placeholder={this.state.suggestedProdNum}/></Col>
              <Col xs={1}></Col>
              {/* <Col xs={3}><Button bsStyle="primary" disabled={!isLinkable} onClick={()=>{this.props.fetchProductsByCategory(this.state.category.ProductCategory_id);this.openLinkProd()}}><Translate value="link_existing_prod" /></Button></Col> */}
            </Row>
          }
          <Row>
            <label className="col-xs-1"> <span className="primary">04</span></label>
            <Col xs={7} className="sizeRadios">
              <Field name="IsLarge" component={ sizeRadios }/>
            </Col>
            <span className="asteriksReq pAbs">*</span>
            <Col xs={4}>
              <Field name="LastDigit" component={ Selection } options={ lastDigitOptions }/>
            </Col>
          </Row>
        </Panel>
        <ButtonToolbar>
          <Button onClick={this.clearFields}>
            <Translate value="clear" />
          </Button>
            <SpinnerButton
              bsStyle="success"
              onClick={this.handleSaveOnClick}
              loading={this.props.updateProductIsLoading}
              icon="fa-save"
              translation={<Translate value="save" />}
              disabled={
                (isGFD && (!this.props.Category || !this.props.Group )) || 
                (!isGFD && (!this.props.Category || !this.props.Group || !this.state.suggestedProdNum || (!LastDigit && LastDigit != 0)))
              }
            />
        </ButtonToolbar>
        </div>
        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.linkProdOpen} onCloseClicked={() => { this.closeLinkProd() } }>
          {this.renderExistingProd()}
        </SkyLightStateless>
      </ContentWrapper>
    )
  }
}

export default EditGroupForm;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/editGroupForm.jsx